import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Button,
} from "web-design-system";
import { DownloadIcon } from "lucide-react";
import { useRouter } from "@tanstack/react-router";

export function DownloadReports({ clientId }: { clientId: number }) {
  const router = useRouter();

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline">
            <DownloadIcon />
            Reports
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem
            onClick={() =>
              router.navigate({
                to: ".",
                search: (prev) => ({
                  ...prev,
                  modal: "portfolio-valuation",
                }),
              })
            }
          >
            Portfolio Valuation
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() =>
              router.navigate({
                to: ".",
                search: (prev) => ({
                  ...prev,
                  modal: "capital-gains",
                }),
              })
            }
          >
            Capital Gains
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() =>
              router.navigate({
                to: ".",
                search: (prev) => ({
                  ...prev,
                  modal: "change-of-broker",
                  client_id: clientId,
                }),
              })
            }
          >
            Change of broker
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  );
}
